/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Predictions API
 * API documentation for Predictions
 * OpenAPI spec version: 1.24.0
 */

/**
 * Net direction.
 */
export type PlaeePositionResponseDtoSide = (typeof PlaeePositionResponseDtoSide)[keyof typeof PlaeePositionResponseDtoSide];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlaeePositionResponseDtoSide = {
  LONG: 'LONG',
  SHORT: 'SHORT',
} as const;
